
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
   ALL_ACADEMYS,
   ADD_ACADEMY,
   ACADEMY_ACTION,
   EDIT_ACADEMY,
   STATUS_ACADEMY,
   DELETE_ACADEMY,
   ALL_PROGRAMINCLUSION
} from 'Actions/types';

/**
 * Redux Action To Sigin User With Firebase
 */
export const allAcademys = () =>{
    
    
    return (dispatch) => { 
        dispatch({ type: ACADEMY_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getacademys', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_ACADEMYS, payload: allroles });
        });
    }    

}

export const roleAcademys = () =>{
    
    
   return (dispatch) => { 
       dispatch({ type: ACADEMY_ACTION });
       return axios.get(AppConfig.apiurl+'/api/getroleacademys', { headers: AuthHeader.header })         
       .then(response => {             
           const allroles=response.data.data;
           dispatch({ type: ALL_ACADEMYS, payload: allroles });
       });
   }    

}

export const addAcademy = (name) => async (dispatch) => {
    
    var payload={
        "name":name
     }
     dispatch({ type: ACADEMY_ACTION });
    return axios.post(AppConfig.apiurl+'/api/addacademy', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allAcademys()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_ACADEMY });
            }else{
               NotificationManager.error(resdata.message); 
            }
            return Promise.resolve(resdata);
         }else{
            NotificationManager.error('Academy not added');
         }          
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const editAcademy = (name,id) => async (dispatch) => {
    
    var payload={
        "id":id,
        "name":name
     }
     dispatch({ type: ACADEMY_ACTION });
    return axios.post(AppConfig.apiurl+'/api/editacademy', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allAcademys()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: EDIT_ACADEMY });
            }else{
               NotificationManager.error(resdata.message); 
            }
            return Promise.resolve(resdata);
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const statusAcademy = (id,status) => async (dispatch) => {
    
    var payload={
        "id":id,
        "status":status
     }
     dispatch({ type: ACADEMY_ACTION });
    axios.post(AppConfig.apiurl+'/api/statusacademy', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allAcademys()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: STATUS_ACADEMY });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const deleteAcademy = (id) => async (dispatch) => {
    
    var payload={
        "id":id
     }
     dispatch({ type: ACADEMY_ACTION });
    axios.post(AppConfig.apiurl+'/api/deleteacademy', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allAcademys()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: DELETE_ACADEMY });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const allProgramInclusion = () =>{    
    
   return (dispatch) => { 
       dispatch({ type: ACADEMY_ACTION });
       return axios.get(AppConfig.apiurl+'/api/getprograminclusions', { headers: AuthHeader.header })         
       .then(response => {             
           const allprogram=response.data.data;          
           dispatch({ type: ALL_PROGRAMINCLUSION, payload: allprogram });
       });
   }
   

}

